import { INFO } from '@app/constants';
import type { NNotificationProvider } from '@app/providers/NotificationProvider/NotificationProvider.types';

// TODO: удалить после завершения бизнес-логики
export const showDevNotification = (
  showNotification: NNotificationProvider.ShowNotificationType
) => {
  showNotification(
    'Данный функционал находится в процессе разработки. ' +
      'Пожалуйста, повторите попытку позднее.',
    INFO
  );
};
